import hashIt from 'hash-it';

export function createUniqueKeyFromObject(object: object) {
  return hashIt(object);
}
